const translations = {
	uk: {
		// Загальні елементи
		'language': 'Мова',
		'uk': 'Українська',
		'en': 'English',

		// Навігація
		'nav.main': 'Головна',
		'nav.past': 'Минуле',
		'nav.present': 'Сьогодення',
		'nav.archaeology': 'Археологія',
		'nav.residents': 'Резиденти',
		'nav.popup': 'Поп-ап',
		'nav.future': 'Майбутнє',
		'nav.contacts': 'Контакти',
		'nav.soon': 'Скоро',
		'nav.menu': 'Меню',

		// Головна сторінка
		'main.title': 'Kudriavka',
		'main.subtitle': 'Вітаємо на сайті Kudriavka',
		'main.description': 'Це колишній Казенний винний склад №1, який зараз ревіталізують. ',
		'main.popup': 'Кудрявка поп-ап',
		'main.arch': 'Археологічні дослідження на Кудрявці',
		'main.form.title': 'Форма звʼязку з Кудрявкою',
		'main.form.name': 'імʼя',
		'main.form.surname': 'Прізвище',
		'main.form.mail': 'E-mail',
		'main.form.message': 'Повідомлення',
		'main.form.button': 'Надіслати',
		'main.form.response': 'Повідомлення успішно відправлено!',
		'main.form.error': 'Помилка відправки повідомлення. Спробуйте ще раз.',
		'main.form.limit': 'Ліміт записів вичерпано. Форма недоступна.',
		'main.form.button.sending': 'Відправляється',
		'main.form.button.sent': 'Відправлено',
		'main.address': 'Вул. Кудрявська, 16А, Київ',

		// Event
		'event.title': 'Форма реєстрації',
		'event.subtitle': '«Музика часу», «Київська камерата»  ',
		'event.description': 'Якщо ви бажаєте отримувати повідомлення про заплановані події, будь ласка, вкажіть зручний для вас спосіб — електронна пошта або телефон — та залиште свої контакти.',
		'event.surname': 'Прізвище',
		'event.date': '26 серпня, 19:00',
		'event.address': 'Піщана зала, вул. Кудрявська 16а, Київ',
		'event.overlimit.title': 'Нажаль, на цю подію вже немає вільних місць.',
		'event.overlimit.subtitle': 'Ми будемо раді бачити вас на Кудрявці на наших наступних заходах.',
		'event.past.title': 'На жаль, реєстрація на цю подію вже закрита.',
		'event.past.subtitle': 'Ми будемо раді бачити вас на Кудрявці на наших наступних заходах.',
		'event.button': 'Надіслати',

		'events': [
			{
				id: 1,
				active: false,
				route: 'archDay_06.10.2025',
				header: 'Форма реєстрації',
				title: '«Всесвітній День архітектури».',
				subtitle: 'Онлайн-лекція Франциска Руш \n(David Chipperfield Architects Berlin)',
				date: '6 жовтня, 18:30',
				disclaimer: 'На жаль, вільних місць офлайн не залишились. Реєстрація доступна тільки онлайн.',
				form: {
					name: 'імʼя',
					surname: 'Прізвище',
					email: 'E-mail/Телефон',
					message: '',
					address: '',
					required: {
						name: true,
						surname: true,
						message: true,
					},
					response: 'Дякуємо за заявку. Посилання на онлайн-трансляцію буде відправлено за вказаним контактом',
					entry: {
						id: '1FAIpQLSe4lgXC6Vu-F9KGU4h7dhtL5nvIR2zPyKpgDOmrY2lYqm-zJg',
						name: 'entry.146328755',
						surname: 'entry.51177726',
						message: 'entry.1521269411',
					},
					limit: null,
					limit_script: '',
				},
				styles: {
					desktop: {
						subtitle:  {
							fontSize: '18px',
							marginTop: '-30px'
						},
					},
					mobile: {
						subtitle:  {
							fontSize: '14px',
							marginTop: '-30px'
						},
					}
				}
			},
			{
				id: 2,
				active: false,
				route: 'guest',
				header: 'Форма реєстрації на концерт',
				title: '«Музика часу», «Київська камерата»',
				subtitle: '',
				date: '26 серпня, 19:00',
				disclaimer: 'Якщо ви бажаєте отримувати повідомлення про заплановані події, будь ласка, вкажіть зручний для вас спосіб — електронна пошта або телефон — та залиште свої контакти.',
				form: {
					name: 'імʼя',
					surname: 'Прізвище',
					email: '',
					message: '',
					required: {
						name: true,
						surname: true,
						message: true,
					},
					address: 'Піщана зала, вул. Кудрявська 16а, Київ',
					response: '',
					entry: {
						id: '1FAIpQLScfj_qTC2s_TetisijoTlkwG3I-iXRLhtWg2al7j8Xv44OKfw',
						name: 'entry.146328755',
						surname: 'entry.170292197',
						message: 'entry.1521269411',
					},
					limit: 130,
					limit_script: 'https://script.google.com/macros/s/AKfycbzMvAmJCoG4I7L4AO1Rj6AbX8-dhgPVNrGO6CPSdhGjVd_53toKetkua1WToJL-lKPT/exec',
				}
			},
			{
				id: 3,
				active: true,
				route: 'Offline_OksanaLevchenja_20.11.2025',
				header: 'Форма реєстрації',
				title: 'Лекція на Кудрявці',
				subtitle: 'Спікерка: Оксана Левченя — художниця, дизайнер-експериментатор, авторка проєкту «Хата Ярова».',
				date: '20 листопада, 18:30',
				disclaimer: 'Коментар',
				form: {
					name: 'імʼя',
					surname: 'Прізвище',
					email: 'E-mail',
					message: '',
					address: '',
					required: {
						name: true,
						surname: true,
						message: false,
					},
					response: 'Дякуємо за реєстрацію. Чекаємо вас на Кудрявці',
					entry: {
						id: '1FAIpQLScVlt5_fo7PC5SigVnRyq8vPPsNO2CbTjjxf3M-oo4WIgPekg',
						name: 'entry.533469335',
						surname: 'entry.1469227497',
						message: 'entry.2089227150',
					},
					limit: null,
					limit_script: '',
				},
				styles: {
					desktop: {
						subtitle:  {
							fontSize: '18px',
							marginTop: '-30px'
						},
					},
					mobile: {
						subtitle:  {
							fontSize: '14px',
							marginTop: '-30px'
						},
					}
				}
			}
		],

		// Сторінка "Минуле"
		'past.title': 'Минуле',
		'past.subtitle': 'Історія Kudriavka',
		'past.description': 'Дізнайтеся більше про історичне минуле цього місця',

		'past.content.intro': 'Кудрявка — це простір культури, який існує між минулим, сьогоденням і майбутнім. ',
		'past.content.history1': 'Комплекс будівель Кудрявки — це <hover:history>історичний обʼєкт</hover:history> кінця 19 століття, який початково був Казенним винним складом № 1, а пізніше став <hover:kyivliquor>Київським лікеро-горілчаним заводом № 2.</hover:kyivliquor> ',
		'past.content.architect': 'Проєкт належить відомому тогочасному архітектору <hover:bessmertnyi>Володимиру Безсмертному.</hover:bessmertnyi> ',
		'past.content.style': 'Київський лікеро-горілчаний завод — взірець так званого «цегляного стилю», який був поширений наприкінці XIX — початку XX ст. Він характерний для великих міст, зокрема в Україні такі будівлі можна знайти в Києві та Одесі. ',
		'past.content.merchantStyle': '<hover:brickstyle>«Цегляний стиль»</hover:brickstyle> ще називали «купецьким». На перетині XIX–XX ст. середній клас у Києві досяг свого розквіту, а торговці почали будувати прибуткові будинки та здавати квартири в оренду. Але декорування фасаду ліпниною чи скульптурою було занадто дорогим, тому весь декор робили зі звичайної цегли. ',
		'past.content.location': 'Розташований на крутому повороті вулиці Кудрявської, формує фронт забудови північної частини кварталу. ',
		'past.content.ancientHistory': 'Простір Кудрявки зберігає історію, яка сягає XI століття, адже локалізується в історичній місцевості з назвою <hover:kopyriv>Копирів кінець.</hover:kopyriv> Їй на зміну прийшов <hover:kudriavets>Кудрявець.</hover:kudriavets> ',
		'past.content.industry': 'Тут був жвавий ремісничий осередок Стародавнього Києва, який паралельно з Подолом відігравав значну роль у житті міста. Зараз Копирів кінець є <hover:archzone>археологічною охоронною зоною.</hover:archzone> ',
		'past.content.monuments': 'Частина будівель та споруд комплексу колишнього Казенного винного складу № 1 є памʼятками та щойно виявленими обʼєктами культурної спадщини: ',
		'past.content.monumentsList': [
			'• Головний корпус, 1896 р. — памʼятка архітектури місцевого значення, охорон. № 1117-Kв (наказ Міністерства культури України від 28.12.2019 p. № 991); ',
			'• Очисне відділення, 1896 р. — памʼятка архітектури місцевого значення, охорон. N° 1119-Kв (наказ Міністерства культури України від 28.12.2019 p. № 991); ',
			'• Спиртосховище, 1896 p. — памʼятка архітектури місцевого значення, охорон. № 1118-Кв (наказ Міністерства культури України від 28.12.2019 p. № 991); ',
			'• Котельня, 1912 p. — памʼятка архітектури місцевого значення, охорон. № 1121-Кв (наказ Міністерства культури України від 28.12.2019 р. № 991); ',
			'• Огорожа, 1896 р. — памʼятка архітектури місцевого значення, охорон. N° 1120-Кв (наказ Міністерства культури України від 28.12.2019 р. № 991); ',
			'• Будинок житловий та конторський Казенного винного складу № 1, 1896 р. — щойно виявлений обʼєкт <hover:culture>культурної спадщини</hover:culture> за видом архітектура та містобудування (наказ Головного управління охорони культурної спадщини від 25.06.2011 p. № 10/38-11); ',
			'• Залізний віадук, 1896-1897 рр., вул. Петрівська — щойно виявлений обʼєкт культурної спадщини за видом архітектура (наказ Управління охорони пам`яток історії, культури та історичного середовища від 26.10.2001 р. № 143). '],
		'past.content.recent': 'Ще до початку 2000-х років завод функціонував за своїм призначенням. Однак після того, як його закрили, історичні будівлі почали руйнуватись та занепадати. ',
		'past.content.future': 'У 2020 році завод придбала Група <link:kovalska>«Ковальська»</link:kovalska> для майбутньої <hover:revit>ревіталізації</hover:revit> цінної промислової спадщини у центрі Києва. Ми хочемо, щоб Кудрявка стала новим культурним осередком і зараз працюємо над архітектурним проєктом ревіталазації з <link:chipperfield>David Chipperfield Architects.</link:chipperfield> ',

		// Сторінка "Археологія"
		'arch.title': 'Археологічні дослідження',
		'arch.subtitle': [
			'Простір Кудрявки зберігає історію, яка сягає XI століття, адже локалізується в історичній місцевості з назвою Копирів кінець, що є археологічною охоронною зоною. Ця територія лишається актуальним місцем для істориків-археологів, які продовжують дослідження культурного шару. Вивчення цієї місцевості почалося ще в ХІХ ст. Відтоді виявлено чимало історичних об’єктів часів Київської держави: фортифікаційні споруди, житлові й господарчі будівлі, ремісничі майстерні, стародавні поховання та чотири кам’яні храми.',
			'Зараз на території тривають нові дослідження, які почалися у 2023 році, та є умовою законодавства перед початком ревіталізації обʼєкта.',
			'Їх проводить Архітектурно-археологічна експедиція Інституту археології НАН України.'
		],

		// Сторінка "Резиденти"
		'residents': [
			{
				'title': 'Artists',
				'list': [
					{ name: 'Жанна Кадирова', link: 'https://www.instagram.com/jannkad' },
					{ name: 'Дарія Кузьмич', link: 'https://www.instagram.com/dariiakuzmych' },
					{ name: 'Олеся Драшкаба', link: 'https://www.instagram.com/drashkaba' },
					{ name: 'Олег Кодрул', link: 'https://www.instagram.com/lucky_strike_gaf' },
					{ name: 'Юлія Захарова', link: 'https://www.instagram.com/zakharova_artist' },
					{ name: 'Катерина Алійник', link: 'https://www.instagram.com/aliinyk.co' },
					{ name: 'Тая Кабаєва', link: 'https://www.instagram.com/taya.kabaeva' }
				]
			},
			{
				'title': 'Musicians',
				'list': [
					{ name: 'Kinero', link: 'https://www.instagram.com/ki_nero' },
					{ name: 'Яр Глобін', link: 'https://www.instagram.com/globinyar' },
					{ name: 'Marri Sienn', link: 'https://www.instagram.com/marri.sienn' },
					{ name: 'Disappeared Completely', link: 'https://www.instagram.com/disappearedcompletely' },
					{ name: 'Renie Cares', link: 'https://www.instagram.com/reniecares' },
					{ name: 'Sera Sheer', link: 'https://www.instagram.com/serasheer' },
					{ name: 'The Emigrant', link: 'https://www.instagram.com/emgrnt' }
				]},
			{
				'title': 'Ceramic studios',
				'list': [
					{ name: 'Zliplena', link: 'https://www.instagram.com/zliplena' },
					{ name: 'Aqyar ceramics', link: 'https://www.instagram.com/aqyar.ceramics' }
				]},
			{
				'title': 'Perfumers',
				'list': [
					{ name: 'Євген Лазарчук', link: 'https://www.instagram.com/yevgen_lazarchuk' },
					{ name: 'Влад Зварич', link: 'https://www.instagram.com/wladua' }
				]
			}
		],
		'residents.others': [
			{
				name: 'АБО',
				about: 'record store, music space',
				link: 'https://www.instagram.com/aborecords'
			},
			{
				name: 'BRUKXT',
				about: 'club and cultural platform',
				link: 'https://www.instagram.com/brukxt'
			},
			{
				name: 'Kutt',
				about: 'table tennis club',
				link: 'https://www.instagram.com/kutt.kyiv/'
			},
			{
				name: '400°',
				about: 'pizzeria',
				link: 'https://www.instagram.com/400.kyiv/'
			},
			{
				name: 'Tea Army',
				about: 'tea culture space',
				link: 'https://www.instagram.com/teaarmy'
			}
		],

		// Сторінка "Поп-ап"
		'popup.title': 'Кудрявка поп-ап — це проєкт у проєкті, тимчасовий простір та тимчасові художні інтервенції на території колишнього заводу. ',
		'popup.subtitle': 'Поки триває розробка проєкту ревіталізації, ми використали наявні можливості, щоби створити публічний простір. Це місце, де можна приємно провести час, відвідати мистецькі та культурні події, а також дізнатися більше про цю локацію.',
		'popup.description': 'Ми завершили перший сезон на Кудрявці і працюємо над оновленням, яке анонсуємо вже скоро.',

		// Сторінка "Майбутнє"
		'future.title': 'Майбутнє',
		'future.subtitle': 'Майбутнє Kudriavka',
		'future.description': 'Плани та перспективи розвитку проекту',

		// Сторінка "Контакти"
		'contacts.title': 'Контакти',
		'contacts.address': 'Вулиця Кудрявська 16a</br>Київ, Україна 04053',
	},

	en: {
		// General elements
		'language': 'Language',
		'uk': 'Ukrainian',
		'en': 'English',

		// Navigation
		'nav.main': 'Home',
		'nav.past': 'Past',
		'nav.present': 'Present',
		'nav.archaeology': 'Archaeology',
		'nav.residents': 'Residents',
		'nav.popup': 'Pop-up',
		'nav.future': 'Future',
		'nav.contacts': 'Contacts',
		'nav.soon': 'Soon',
		'nav.menu': 'Menu',

		// Home page
		'main.title': 'Kudriavka',
		'main.subtitle': 'Welcome to the Kudriavka website',
		'main.description': 'This is the former State Wine Warehouse No. 1, which is currently being revitalized. ',
		'main.popup': 'Kudriavka Pop-up',
		'main.arch': 'Archaeological research at Kudriavka',
		'main.form.title': 'Contact form for Kudriavka',
		'main.form.name': 'Name',
		'main.form.surname': 'Surname',
		'main.form.mail': 'E-mail',
		'main.form.message': 'Message',
		'main.form.button': 'Send',
		'main.form.button.sending': 'Sending',
		'main.form.button.sent': 'Sent',
		'main.form.response': 'Message successfully sent!',
		'main.form.error': 'Error sending message. Please try again.',
		'main.form.limit': 'The record limit has been reached. The form is unavailable.',
		'main.address': 'Kudriavska St, 16A, Kyiv',

		// Event
		'event.title': 'Registration Form',
		'event.subtitle': '“Music of Time”, “Kyiv Camerata”',
		'event.description': 'If you would like to receive notifications about upcoming events, please indicate your preferred contact method — email or phone — and leave your contact details.',
		'event.surname': 'Last Name',
		'event.date': 'August 26, 7:00 PM',
		'event.address': 'Sand Hall, Kudriavska St, 16A, Kyiv',
		'event.overlimit.title': 'Unfortunately, there are no more places available for this event.',
		'event.overlimit.subtitle': 'We look forward to seeing you at Kudriavka for our upcoming events.',
		'event.past.title': 'Unfortunately, registration for this event is closed.',
		'event.past.subtitle': 'We look forward to seeing you at Kudriavka for our upcoming events.',
		'event.button': 'Send',

		'events': [
			{
				id: 1,
				active: false,
				route: 'archDay_06.10.2025',
				header: 'Registration Form',
				title: '“World Architecture Day”',
				subtitle: 'Online lecture by Franziska Rusch \n(David Chipperfield Architects Berlin)',
				date: 'October 6, 18:30',
				disclaimer: 'Unfortunately, there are no offline spots left. Registration is only available online.',
				form: {
					name: 'First Name',
					surname: 'Last Name',
					email: 'E-mail/Phone',
					message: '',
					address: '',
					required: {
						name: true,
						surname: true,
						message: true,
					},
					response: 'Thank you for your application. A link to the online broadcast will be sent to the contact details provided.',
					entry: {
						id: '1FAIpQLSe4lgXC6Vu-F9KGU4h7dhtL5nvIR2zPyKpgDOmrY2lYqm-zJg',
						name: 'entry.146328755',
						surname: 'entry.51177726',
						message: 'entry.1521269411',
					},
					limit: null,
					limit_script: '',
				},
				styles: {
					desktop: {
						subtitle: {
							fontSize: '18px',
							marginTop: '-30px'
						},
					},
					mobile: {
						subtitle: {
							fontSize: '14px',
							marginTop: '-30px'
						},
					}
				}
			},
			{
				id: 2,
				active: false,
				route: 'guest',
				header: 'Concert Registration Form',
				title: '“Music of Time”, “Kyiv Camerata”',
				subtitle: '',
				date: 'August 26, 19:00',
				disclaimer: 'If you would like to receive notifications about upcoming events, please indicate your preferred method — email or phone — and leave your contact information.',
				form: {
					name: 'First Name',
					surname: 'Last Name',
					email: '',
					message: '',
					required: {
						name: true,
						surname: true,
						message: true,
					},
					address: 'Sand Hall, 16a Kudryavska St., Kyiv',
					response: '',
					entry: {
						id: '1FAIpQLScfj_qTC2s_TetisijoTlkwG3I-iXRLhtWg2al7j8Xv44OKfw',
						name: 'entry.146328755',
						surname: 'entry.170292197',
						message: 'entry.1521269411',
					},
					limit: 130,
					limit_script: 'https://script.google.com/macros/s/AKfycbzMvAmJCoG4I7L4AO1Rj6AbX8-dhgPVNrGO6CPSdhGjVd_53toKetkua1WToJL-lKPT/exec',
				}
			},
			{
				id: 3,
				active: true,
				route: 'Offline_OksanaLevchenja_20.11.2025',
				header: 'Registration Form',
				title: 'Lecture at Kudryavka',
				subtitle: 'Speaker: Oksana Levchenia — artist, experimental designer, author of the project "Khata Yarova".',
				date: 'November 20, 6:30 PM',
				disclaimer: 'Comment',
				form: {
					name: 'First name',
					surname: 'Last name',
					email: 'E-mail',
					message: '',
					address: '',
					required: {
						name: true,
						surname: true,
						message: false,
					},
					response: 'Thank you for registering. We look forward to seeing you at Kudryavka.',
					entry: {
						id: '1FAIpQLScVlt5_fo7PC5SigVnRyq8vPPsNO2CbTjjxf3M-oo4WIgPekg',
						name: 'entry.533469335',
						surname: 'entry.1469227497',
						message: 'entry.2089227150',
					},
					limit: null,
					limit_script: '',
				},
				styles: {
					desktop: {
						subtitle: {
							fontSize: '18px',
							marginTop: '-30px'
						},
					},
					mobile: {
						subtitle: {
							fontSize: '14px',
							marginTop: '-30px'
						},
					}
				}
			}
		],

		// Past page
		'past.title': 'Past',
		'past.subtitle': 'History of Kudriavka',
		'past.description': 'Learn more about the historical past of this place',

		'past.content.intro': 'Kudriavka is where culture flows through time bridging the past, present, and future.',
		'past.content.history1': 'This <hover:history>historical industrial complex</hover:history> in central Kyiv dates back to the late 1800s. Originally built as State Wine Warehouse No. 1, it later became <hover:kyivliquor>Kyiv Distillery No. 2.</hover:kyivliquor> ',
		'past.content.architect': 'The project was designed by the prominent architect of the time, <hover:bessmertnyi>Volodymyr Bezsmertnyi.</hover:bessmertnyi> ',
		'past.content.style': 'Kyiv Distillery is a fine example of the so-called “brick style”, a popular architectural approach at the turn of the 20th century. Such buildings were typical in large Ukrainian cities like Kyiv and Odesa. ',
		'past.content.merchantStyle': 'The <hover:brickstyle>“brick style”</hover:brickstyle> was also referred to as “merchant style”. At the turn of the nineteenth and twentieth centuries, the middle class in Kyiv flourished, and merchants began to build apartment blocks for rental income. Yet the cost of decorating the facade with stucco or sculpture was too expensive, so they used ordinary bricks. ',
		'past.content.location': 'Located on a sharp bend on Kudriavska Street, it forms the building frontage of the northern part of the quarter. ',
		'past.content.ancientHistory': 'The Kudriavka site preserves a history that dates back to the 11th century as it is located in a historical area called <hover:kopyriv>Kopyriv Kinets.</hover:kopyriv> It was replaced later by <hover:kudriavets>Kudriavets.</hover:kudriavets> ',
		'past.content.industry': 'It was a vibrant artisanal hub of Ancient Kyiv, which played a significant role in the city life along with Podil. Today, Kopyriv Kinets is recognized as an official <hover:archzone>archaeological heritage zone.</hover:archzone> ',
		'past.content.monuments': 'Some of the buildings and constructions of the former State Wine Warehouse No. 1 are landmarks and newly discovered cultural heritage sites: ',
		'past.content.monumentsList': [
			'• Main Building, 1896 – an architectural landmark of local significance, protected by the state registration No. 1117-Kv (Order of the Ministry of Culture of Ukraine of 28.12.2019, No. 991); ',
			'• Cleaning Department, 1896 – an architectural landmark of local significance, protected by the state registration No. 1119-Kv (order of the Ministry of Culture of Ukraine of 28.12.2019, No. 991); ',
			'• Spirits Storehouse, 1896 – an architectural landmark of local significance, protected by the state registration No. 1118-Kv (order of the Ministry of Culture of Ukraine of 28.12.2019, No. 991); ',
			'• Boiler House, 1912 – an architectural landmark of local significance, protected by the state registration No. 1121-Kv (order of the Ministry of Culture of Ukraine of 28.12.2019, No. 991); ',
			'• Fence, 1896 – an architectural landmark of local significance, protected by the state registration No. 1120-Kv (order of the Ministry of Culture of Ukraine of 28.12.2019, No. 991); ',
			'• Residential and administrative building of the State Wine Warehouse No. 1, 1896 – newly discovered <hover:culture>cultural heritage site</hover:culture> by the type of architecture and urban planning (order of the Main Department of Cultural Heritage Protection of 25.06.2011, No. 10/38-11); ',
			'• Iron Viaduct, 1896-1897, Petrivska street—a newly discovered cultural heritage site by the type of architecture (order of the Department of Historical, Cultural and Historical Environment Protection of 26.10.2001, No. 143). '
		],
		'past.content.recent': 'The distillery continued to operate until the early 2000s. After its closure, however, the historical buildings began to deteriorate. ',
		'past.content.future': 'In 2020, the plant was acquired by the <link:kovalska>Kovalska Group</link:kovalska> for the future <hover:revit>revitalization </hover:revit> of valuable industrial heritage in the center of Kyiv. We’re currently developing a revitalization project in collaboration with <link:chipperfield>David Chipperfield Architects</link:chipperfield>, aiming to reimagine Kudriavka as a vibrant cultural destination. ',

		// Archaeology page
		'arch.title': 'Archaeological Research',
		'arch.subtitle': [
			'The Kudriavka site preserves a history dating back to the 11th century as it is located in a historical area called Kopyriv Kinets, an archaeological protection zone. This area remains of great interest to historians and archaeologists, who continue to study its rich cultural strata. The study of this area began in the 19th century. Since then, many historical sites from the Kyivan Rus’ period have been discovered: fortifications, residential and commercial buildings, artisan workshops, ancient burials, and four stone churches.',
			'New research began in 2023, and it constitutes a legal prerequisite for any revitalization of the site.',
			'These are being conducted by the Architectural and Archaeological Expedition of the Institute of Archaeology of the National Academy of Sciences of Ukraine. ',
		],

		// Residents page
		'residents': [
			{
				'title': 'Artists',
				'list': [
					{ name: 'Zhanna Kadyrova', link: 'https://www.instagram.com/jannkad' },
					{ name: 'Dariia Kuzmych', link: 'https://www.instagram.com/dariiakuzmych' },
					{ name: 'Olesya Drashkaba', link: 'https://www.instagram.com/drashkaba' },
					{ name: 'Oleg Kodrul', link: 'https://www.instagram.com/lucky_strike_gaf' },
					{ name: 'Julia Zakharova', link: 'https://www.instagram.com/zakharova_artist' },
					{ name: 'Kateryna Aliinyk', link: 'https://www.instagram.com/aliinyk.co' },
					{ name: 'Taya Kabayeva', link: 'https://www.instagram.com/taya.kabaeva' }
				]
			},
			{
				'title': 'Musicians',
				'list': [
					{ name: 'Kinero', link: 'https://www.instagram.com/ki_nero' },
					{ name: 'Yar Globyn ', link: 'https://www.instagram.com/globinyar' },
					{ name: 'Marri Sienn', link: 'https://www.instagram.com/marri.sienn' },
					{ name: 'Disappeared Completely', link: 'https://www.instagram.com/disappearedcompletely' },
					{ name: 'Renie Cares', link: 'https://www.instagram.com/reniecares' },
					{ name: 'Sera Sheer', link: 'https://www.instagram.com/serasheer' },
					{ name: 'The Emigrant', link: 'https://www.instagram.com/emgrnt' }
				]},
			{
				'title': 'Ceramic studios',
				'list': [
					{ name: 'Zliplena', link: 'https://www.instagram.com/zliplena' },
					{ name: 'Aqyar ceramics', link: 'https://www.instagram.com/aqyar.ceramics' }
				]},
			{
				'title': 'Perfumers',
				'list': [
					{ name: 'Yevgen Lazarchuk', link: 'https://www.instagram.com/yevgen_lazarchuk' },
					{ name: 'Vlad Zvarych', link: 'https://www.instagram.com/wladua' }
				]
			}
		],
		'residents.others': [
			{
				name: 'АБО',
				about: 'record store, music space',
				link: 'https://www.instagram.com/aborecords'
			},
			{
				name: 'BRUKXT',
				about: 'club and cultural platform',
				link: 'https://www.instagram.com/brukxt'
			},
			{
				name: 'Kutt',
				about: 'table tennis club',
				link: 'https://www.instagram.com/kutt.kyiv/'
			},
			{
				name: '400°',
				about: 'pizzeria',
				link: 'https://www.instagram.com/400.kyiv/'
			},
			{
				name: 'Tea Army',
				about: 'tea culture space',
				link: 'https://www.instagram.com/teaarmy'
			}
		],

		// Pop-up page
		'popup.title': 'Kudriavka Pop-up is a project within a project, a temporary space and artistic interventions on the premises of the former factory. ',
		'popup.subtitle': 'While full redevelopment is still in progress, we have taken advantage of what was available to us to create a public space where people can relax, enjoy art, and cultural events, and explore the area’s history. ',
		'popup.description': 'We have completed the first season at Kudriavka and are working on an update, which we will announce soon.',

		// Future page
		'future.title': 'Future',
		'future.subtitle': 'The Future of Kudriavka',
		'future.description': 'Plans and prospects for the project’s development',

		// Contacts page
		'contacts.title': 'Contacts',
		'contacts.address': 'Kudriavska Street 16a<br>Kyiv, Ukraine 04053',
	}
};

export const getTranslation = (key, lang) => {
	if (!translations[lang] || !translations[lang][key]) {
		console.warn(`Translation missing: ${key} for language: ${lang}`);
		return key;
	}
	return translations[lang][key];
};

export class LanguageManager {
	constructor() {
		this.currentLanguage = localStorage.getItem('language') || 'uk';
	}

	getCurrentLanguage() {
		return this.currentLanguage;
	}

	setLanguage(lang) {
		if (translations[lang]) {
			this.currentLanguage = lang;
			localStorage.setItem('language', lang);
			document.documentElement.setAttribute('lang', lang);
			return true;
		}
		return false;
	}

	t(key) {
		return getTranslation(key, this.currentLanguage);
	}
}

export const languageManager = new LanguageManager();